export default function playVideoOnViewPort() {

  const $videos = document.querySelectorAll("#wrapbenefits video");

  $videos.forEach((video) => {

    const observer = new IntersectionObserver((entries) => {

      if (entries[0].isIntersecting) {
        setTimeout(() => video.play(), 1000);
        observer.disconnect();
      }

    });

    observer.observe(video);

  });

}